import React from "react";
import type { ComponentProps, PartData } from "@enonic/react-components";

import { formatPublishDate } from "/react4xp/components/shared/lib/Utils";
import type { AuthorPublishDatePartProps } from "./AuthorPublishDate.d";

export const AuthorPublishDatePart = (props: ComponentProps<PartData>) => {
  const { author, publishDate } =
    (props.data as AuthorPublishDatePartProps) ?? {};

  return (
    <aside className="article-byline">
      <p>Publisert {formatPublishDate(publishDate)}</p>
      {author && <p>Av: {author}</p>}
    </aside>
  );
};

export default AuthorPublishDatePart;
